<template>
  <div
    :id="id"
    class="custom-file"
    v-if="!alternateTemplate"
  >
    <input
      type="file"
      class="custom-file-input"
      :accept="acceptedFileMimeTypes"
      :multiple="allowMultiple"
      :disabled="disabled"
      @change="setFile"
    >
    <label
      class="custom-file-label"
      :data-browse="$t('file_input_select_browse')"
    >
      <span id="selected-file"> {{$t(selectedFilesLabel)}}</span>
    </label>
  </div>
  <div
    class="d-flex flex-row justify-content-space-between"
    v-else
  >
    <div class="file-selector">
      <input
        type="file"
        class="short-file-input"
        ref="inputFile"
        :disabled="disabled"
        :accept="acceptedFileMimeTypes"
        :multiple="allowMultiple"
        @change="setFile"
        name="file"
        :id="id"
      >
      <label
        v-if="!empty"
        id="file-tag"
        :for="id"
      >
        <slot>
          <div class="add-file icon icon--12 icon--add"></div>
        </slot>
      </label>
    </div>
  </div>

</template>

<script>

export default {
  props: {
    id: {
      type: [String, Number]
    },
    allowMultiple: {
      type: Boolean,
      default: false
    },
    alternateTemplate: {
      type: Boolean,
      default: false
    },
    empty: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      files: []
    }
  },
  computed: {
    selectedFilesLabel () {
      if (this.files.length > 1) {
        return this.$t('file_input_amount_files_selected', { amount: this.files.length })
      }
      if (this.files.length === 1) {
        return `${this.files[0].name}`
      }
      return 'file_input_select_file'
    },
    acceptedFileMimeTypes () {
      return 'image/jpeg,image/jpg,image/png,application/pdf,application/x-pdf'
    }
  },
  methods: {
    setFile (event) {
      this.files = []

      if (!this.allowMultiple) {
        this.files = event.target.files[0]
      } else {
        this.files = event.target.files
      }
      this.$emit('change', this.files)
    }
  }
}

</script>

<style scoped>
label {
  margin: 0;
}

#selected-file {
  display: inline-block;
  position: relative;
  width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.short-file-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.short-file-input + label {
  font-weight: 700;
  display: inline-block;
  cursor: pointer;
}

.add-file {
  width: 100%;
  padding: 1px 5px;
}
</style>
